import { isPlatformBrowser, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, ElementRef, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { InnerHTMLPipe } from 'app/core/pipes/innerHTML.pipe';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { Subject, takeUntil } from 'rxjs';
import { FooterComponent } from '../landing/footer/footer.component';


@Component({
  standalone: true,
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  imports: [NgIf, NgFor, MatExpansionModule, InnerHTMLPipe, NgClass, MatIconModule, MatButtonModule, RouterLink, MatFormFieldModule, MatInputModule, FooterComponent, FuseCardComponent, MatTabsModule, NgFor]
})

export class SupportComponent {

  @ViewChild("faqs") myFaqs: ElementRef;

  public headerImage: string;
  public headerTitle: string;
  public headerTextColor: string;
  public bodyContent: any;
  public bodyContentFiltered: any;
  public faqCategories: any;
  public categoryTypes: any;
  public faqsContent: any;
  public selectedCategory: string;
  public selectedSubCategory: number;
  public panelOpened: boolean;

  private isScreenSmall: boolean;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  private referrer: string;

  constructor(
    private _strapiService: StrapiService,
    private router: Router,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private route: ActivatedRoute,
    private _gtmService: GtmService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
  }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {

      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }

      const route = window.location.href;
      const path = this.router.url;
      this._gtmService.pushEvent({ 
        event: 'page_view' ,
        page_url: route,
        page_path: path,
        page_title: 'support_page' ,
        page_referrer: this.referrer ? this.referrer : route
      });
    }

    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });

    this._strapiService.getSupportPageHeader().subscribe({
      next: (res: any) => {
        if (this.isScreenSmall) {
          this.headerImage = res.data.mobileImage.url;
        } else {
          this.headerImage = res.data.image.url;
        }
        this.headerTitle = res?.data.headerText;
        this.headerTextColor = res.data.text_color_hex;
      },
    });

    this._strapiService.getSupportPageScreenContent().subscribe({
      next: (res: any) => {

        this.categoryTypes = [];
        this.bodyContent = res.data;

        this.bodyContent.forEach(element => {
          this.categoryTypes.push({ title: element.support_category.categoryTitle })
        });

        // filter duplicates
        this.categoryTypes = this.categoryTypes.filter(
          (obj, index) =>
            this.categoryTypes.findIndex((item) => item.title === obj.title) === index
        );

        this.categoryTypes.flat()


        this.checkCatType()


        this.handleNavParams();
        // this.toggleCategory(this.categoryTypes[0].title);

      },
    });





  }

  ngAfterViewInit() {
    setTimeout(() => {
      const links = document.querySelectorAll('.faq-content'); // Add a class to your wrapper div like `.faq-content`
      links.forEach(link => {
        link.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });
    });
  }

  /**
     * On destroy
     */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    localStorage.removeItem('catType');
  }

  public redirectToWhatsApp() {
    if (isPlatformBrowser(this.platformId)) {
      window.open('https://api.whatsapp.com/send/?phone=0600687377&text=Please+can+you+assist+me', '_blank');
    }
  }

  public supportById(id: number) {

    this.selectedSubCategory = id;

    this._strapiService.getSupportPageScreenContentById(id).subscribe({
      next: (res: any) => {
        this.faqsContent = res.data;
      },
    });

    // this.myFaqs?.nativeElement?.scrollIntoView({ behavior: "smooth", block: "start" });

    //this.router.navigate(['/support', id]);
  }

  public toggleCategory(catType: string) {
   
    this.selectedCategory = catType;

    this.faqsContent = null

    this.bodyContentFiltered = this.bodyContent.filter(bc => bc.support_category.categoryTitle == catType)

    this.bodyContentFiltered = this.bodyContentFiltered.sort((b) => { b.renderPriority - b.renderPriority });

  }

  public checkCatType() {

    const storedCatType = localStorage.getItem('catType');

    if (localStorage.getItem('catType') == 'Products') {
      this.toggleCategory(storedCatType);
    } else {
      this.toggleCategory(this.categoryTypes[0].title)
    }

  }

  public getItemFromNav(itemName: string) {
    this.bodyContentFiltered.forEach(element => {
      const topicName:string = element.topic.toLowerCase()
      if (topicName.includes(itemName)) {
        this.supportById(element.id);
      }
    });
  }

  private handleNavParams(){
    this.route.fragment.subscribe((fragment: string | null) => {
      if (fragment) {
        localStorage.removeItem("catType");
        this.checkCatType();
        if (fragment === 'process' || fragment === 'billing') {
          this.getItemFromNav(fragment);
        }else{
          this.toggleCategory(fragment)
        }
      }
    });
  }


}
